import qs from "qs";
import api from "./api";

const Jobs = {
    async create(data) {
        return await api.post(`/v1/business/jobs?type=business`, data);
    },
    async list(page, limit, idCustomer, data = null) {
        return await api.get(`/v1/business/customer/${idCustomer}/jobs`, {
            params: { page, limit, data },
        });
    },
    async listDelivered({ filters = {}, page = 1 }) {
        const dataFilters = {
            ...filters,
            period: { ...filters.period },
            onlyPendingDownload: filters.onlyPendingDownload ? filters.onlyPendingDownload : undefined,
        };

        if (filters?.period?.[0]?.includes("/")) {
            dataFilters.period[0] = filters.period[0].split("/").reverse().join("-");
        }

        if (filters?.period?.[1]?.includes("/")) {
            dataFilters.period[1] = filters.period[1].split("/").reverse().join("-");
        }

        const query = qs.stringify({ page, filters: dataFilters });
        return api.get(`/v1/customer/jobs/delivered?${query}`).then((res) => res.data);
    },
    async search(page, filters = {}, { limit = 20, delivered = false } = {}) {
        const params = qs.stringify({ page, filters, limit });
        return api.get(`/v2/users/search-jobs${delivered ? "/delivered" : ""}?${params}`);
    },
    async stats() {
        return api.get(`/v2/users/jobs/stats`).then((res) => res.data);
    },
    async details(idJob, idCustomer) {
        return await api.get(`/v1/business/customer/${idCustomer}/jobs/${idJob}`);
    },
    async view(data) {
        return await api.get(`/v1/business/jobs/${data}/decode`);
    },
    async update({ token, data }) {
        return await api.patch(`/v1/business/jobs/${token}/updateJobByToken`, data);
    },
    async cancel(idJob, reason = "", observation = "", canSendRescheduleLink = false, selectedJobs = []) {
        return await api.patch(`/v1/business/jobs/scheduling/${idJob}`, {
            reasonId: reason,
            cancelObservation: observation,
            canSendRescheduleLink: canSendRescheduleLink,
            selectedJobs
        });
    },
    async cancelByToken(jobId, token, reason = "", observation = "", selectedJobs = []) {
        return await api.patch(`/v2/jobs/${jobId}/cancel-by-token?token=${token}`, {
            cancelDate: new Date(),
            reasonId: reason,
            cancelObservation: observation,
            selectedJobs
        });
    },
    async cancelMaketplaceJob(idJob, reason = "", observation = "") {
        return await api.patch(`/v2/jobs/marketplace/cancel/${idJob}`, {
            cancelReason: reason,
            cancelObservation: observation,
        });
    },
    async updateMaketplaceJob(idJob, data) {
        return await api.patch(`/v2/jobs/marketplace/update/${idJob}`, data);
    },

    async checkForAddressDuplication({ address, number, complement, neighborhood, cityName, stateAbbr, customerCode }) {
        return api.post(`/v1/organizations/jobs/check-same-address`, {
            address,
            number,
            complement,
            neighborhood,
            cityName,
            stateAbbr,
            customerCode,
        });
    },
    async reschedule(jobId, { date, time, period, jobsInSamePlace = [] }) {
        const query = qs.stringify({ jobsInSamePlace })
        return api.patch(`/v1/business/jobs/${jobId}/reschedule?${query}`, { date, time, period });
    },

    async marketplaceDetails(jobId, photographerId) {
        return api.get(`/v1/marketplace/jobs/${jobId}/details/${photographerId}`).then((res) => res.data);
    },
    async getJobExecutionDashboard(filters = {}) {
        const query = qs.stringify({ filters });
        return api.get(`/v1/dashboards/customer/execution?${query}`).then((res) => res.data);
    },
    async updateAddress(jobId, data) {
        const path = `/v1/jobs/${jobId}/address`;
        return api.patch(path, data);
    },
    async sendOwnerMesageConfirmation({ jobIds = [] }) {
        return api.post(`/v1/dashboards/owner-communication?retrieveMessage=1`, { jobIds }).then(res => res.data);
    },
    async updateStatus(data, idJob) {
        return api.patch(`/v1/jobs/${idJob}/status`, data);
    },
    async updateConfirmationStatus({ jobIds, status = "nao_confirmado" }) {
        return api.patch(`/v1/dashboards/owner-communication`, { jobIds, status }).then(res => res.data);
    },
    async setChoosedPhotographer(jobId, partnerId, notifyByEmail = false, notifyLocalContact = false) {
        const path = `/v1/jobs/${jobId}/assoc-photographer/${partnerId}`;

        return api.patch(path, {
            notifyOwnerAndLocalContactByEmail: notifyByEmail,
            notifyLocalContactsByWhatsapp: notifyLocalContact
        });
    },
    async setChoosedPhotographerToJobs(jobIds, partnerId, notifyByEmail = false, notifyLocalContact = false) {
        const path = `/v1/jobs/batch/assoc-photographer/${partnerId}`;

        return api.patch(path, {
            notifyOwnerAndLocalContactByEmail: notifyByEmail,
            notifyLocalContactsByWhatsapp: notifyLocalContact,
            jobIds
        });
    },
    async sendOnwerPhotographerDetails({ jobIds = [] }) {
        return api.post(`/v1/dashboards/owner-details?retrieveMessage=1`, { jobIds }).then(res => res.data);
    },
    async getPhotographersToCommunication(filters = {}) {
        const query = qs.stringify({ filters });
        return api.get(`/v1/dashboards/photographer-communication?${query}`).then(res => res.data);
    },
    async sendEmailDuplicatedJob(job = {}){
        return api.patch(`v1/jobs/duplicated-job`, {job}).then( res => res.data)
    }
};

export default Jobs;
